import { useContext, useEffect, useState } from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import PageTransition from "../../../../app/animations/page-transition";
import WalletTransactionAlert from "../../../../app/components/wallet-transaction-alert";
import config from "../../../../app/config";
import { WalletContext } from "../../../../app/contexts/wallet-context";
import { tokenFormat } from "../../../../app/utilities/format";

const Unstake = () => {
  const wallet = useContext(WalletContext);
  const { user } = wallet;
  const { delband } = wallet.walletAccount;
  const [formData, setFormData] = useState({
    from: "",
    receiver: "",
    unstake_net_quantity: 0,
    unstake_cpu_quantity: 0,
  });

  useEffect(() => {
    setFormData((formData) => ({
      ...formData,
      from: user ? user.actor : "",
    }));
  }, [user]);

  const handleClick = async () => {
    var walletTransaction = {};
    walletTransaction.type = "undelegatebw";
    // walletTransaction.account = {
    //   account: null,
    //   permission: "active",
    // };
    walletTransaction.actions = [];

    walletTransaction.actions.push({
      account: "eosio",
      name: "undelegatebw",
      data: {
        from: formData.from,
        receiver: formData.receiver,
        unstake_cpu_quantity: `${tokenFormat(formData.unstake_cpu_quantity)} ${
          config.token_symbol
        }`,
        unstake_net_quantity: `${tokenFormat(formData.unstake_net_quantity)} ${
          config.token_symbol
        }`,
        transfer: formData.transfer,
      },
    });

    wallet.submitTransaction(walletTransaction);
  };

  return (
    <>
     <Helmet>
        <title>Unstake | Wallet - WAX Explorer</title>
      </Helmet>
      <PageTransition>
        <div className="container border p-2">
          <form>
            <div className="mb-3">
              <label className="form-label">Account name to unstake from</label>
              <input
                type="text"
                className="form-control dropdown-toggle"
                value={formData.receiver}
                onChange={(event) =>
                  setFormData({ ...formData, receiver: event.target.value })
                }
                id="dropdownMenuUnstakeReceiver"
                data-bs-toggle="dropdown"
                autoComplete="off"
              />
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuUnstakeReceiver"
              >
                {delband &&
                  delband.rows.map((row, index) => (
                    <li key={index}>
                      <Link
                        className="dropdown-item"
                        to=""
                        onClick={(event) => {
                          event.preventDefault();
                          setFormData({ ...formData, receiver: row.to })
                        }}
                      >
                        {`${row.to} (CPU: ${row.cpu_weight} , NET: ${row.net_weight})`}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
            <div className="mb-3">
              <label className="form-label">Amount of WAX to unstake from CPU</label>
              <input
                type="number"
                className="form-control"
                value={formData.unstake_cpu_quantity}
                onChange={(event) =>
                  setFormData({
                    ...formData,
                    unstake_cpu_quantity: event.target.value,
                  })
                }
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Amount of WAX to unstake from NET</label>
              <input
                type="number"
                className="form-control"
                value={formData.unstake_net_quantity}
                onChange={(event) =>
                  setFormData({
                    ...formData,
                    unstake_net_quantity: event.target.value,
                  })
                }
              />
            </div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleClick()}
            >
              {formData.unstake_cpu_quantity > 0 ||
              formData.unstake_net_quantity > 0
                ? `Unstake ${formData.unstake_cpu_quantity} ${config.token_symbol}
                of CPU and
                ${formData.unstake_net_quantity} ${config.token_symbol}
                of NET`
                : `Unstake`}
            </button>
          </form>
        </div>
        <WalletTransactionAlert />
      </PageTransition>
    </>
  );
};

export default Unstake;
